import React from 'react';
import { Wallet, CheckCircle, AlertCircle, ExternalLink } from 'lucide-react';
import { useWallet } from './WalletContext';

const MetaMaskIcon = () => (
  <svg viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <path d="M32.9582 1L19.4834 11.3506L21.9615 5.60796L32.9582 1Z" fill="#E17726" stroke="#E17726" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.65789 1L16.0085 11.4428L13.654 5.60796L2.65789 1Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M28.1662 23.6744L24.5316 29.3471L32.0981 31.5137L34.3577 23.7767L28.1662 23.6744Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.27271 23.7767L3.51904 31.5137L11.0854 29.3471L7.45082 23.6744L1.27271 23.7767Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.7176 14.3673L8.61963 17.4788L16.1288 17.8316L15.8541 9.67578L10.7176 14.3673Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24.898 14.3673L19.6854 9.58301L19.4834 17.8316L26.9926 17.4788L24.898 14.3673Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0854 29.3471L15.6914 27.0981L11.6726 23.8311L11.0854 29.3471Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.9242 27.0981L24.5316 29.3471L23.943 23.8311L19.9242 27.0981Z" fill="#E27625" stroke="#E27625" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24.5316 29.3471L19.9242 27.0981L20.3026 30.0878L20.2612 31.421L24.5316 29.3471Z" fill="#D5BFB2" stroke="#D5BFB2" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0854 29.3471L15.3558 31.421L15.3271 30.0878L15.6914 27.0981L11.0854 29.3471Z" fill="#D5BFB2" stroke="#D5BFB2" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.4199 22.0203L11.5425 20.8672L14.3158 19.5732L15.4199 22.0203Z" fill="#233447" stroke="#233447" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.1957 22.0203L21.2998 19.5732L24.086 20.8672L20.1957 22.0203Z" fill="#233447" stroke="#233447" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0854 29.3471L11.6997 23.6744L7.45082 23.7767L11.0854 29.3471Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.9158 23.6744L24.5316 29.3471L28.1662 23.7767L23.9158 23.6744Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M26.9926 17.4788L19.4834 17.8316L20.1971 22.0203L21.3012 19.5732L24.0874 20.8672L26.9926 17.4788Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5425 20.8672L14.3286 19.5732L15.4199 22.0203L16.1288 17.8316L8.61963 17.4788L11.5425 20.8672Z" fill="#CC6228" stroke="#CC6228" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.61963 17.4788L11.6726 23.8311L11.5425 20.8672L8.61963 17.4788Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24.0874 20.8672L23.943 23.8311L26.9926 17.4788L24.0874 20.8672Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.1288 17.8316L15.4199 22.0203L16.3037 26.5486L16.5098 20.5335L16.1288 17.8316Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.4834 17.8316L19.1138 20.5221L19.3118 26.5486L20.1971 22.0203L19.4834 17.8316Z" fill="#E27525" stroke="#E27525" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.1971 22.0203L19.3118 26.5486L19.9242 27.0981L23.943 23.8311L24.0874 20.8672L20.1971 22.0203Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5425 20.8672L11.6726 23.8311L15.6914 27.0981L16.3037 26.5486L15.4199 22.0203L11.5425 20.8672Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.2612 31.421L20.3026 30.0878L19.9499 29.7797H15.6654L15.3271 30.0878L15.3558 31.421L11.0854 29.3471L12.6137 30.5978L15.6269 32.6717H19.9886L23.0018 30.5978L24.5316 29.3471L20.2612 31.421Z" fill="#C0AC9D" stroke="#C0AC9D" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.9242 27.0981L19.3118 26.5486H16.3037L15.6914 27.0981L15.3271 30.0878L15.6654 29.7797H19.9499L20.3026 30.0878L19.9242 27.0981Z" fill="#161616" stroke="#161616" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M33.4997 11.8854L34.6554 6.40354L32.9582 1L19.9242 10.8458L24.898 14.3673L32.0337 16.4066L33.5647 14.5942L32.9152 14.1203L34.0023 13.1311L33.2058 12.5137L34.2929 11.6701L33.4997 11.8854Z" fill="#763E1A" stroke="#763E1A" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1 6.40354L2.15568 11.8854L1.34888 11.6701L2.43595 12.5137L1.64071 13.1311L2.72778 14.1203L2.07828 14.5942L3.60928 16.4066L10.7176 14.3673L15.6914 10.8458L2.65789 1L1 6.40354Z" fill="#763E1A" stroke="#763E1A" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M32.0337 16.4066L24.898 14.3673L26.9926 17.4788L23.943 23.8311L28.1662 23.7767H34.3577L32.0337 16.4066Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.7176 14.3673L3.60928 16.4066L1.27271 23.7767H7.45082L11.6726 23.8311L8.61963 17.4788L10.7176 14.3673Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.4834 17.8316L19.9242 10.8458L21.9757 5.60796H13.654L15.6914 10.8458L16.1288 17.8316L16.2905 20.5449L16.3037 26.5486H19.3118L19.3251 20.5449L19.4834 17.8316Z" fill="#F5841F" stroke="#F5841F" strokeWidth="0.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const OKXIcon = () => (
  <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="200" height="200" rx="40" fill="#CDFA50"/>
    <g transform="translate(30, 30)">
      <rect x="0" y="48" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="51" y="0" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="51" y="48" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="51" y="96" width="38" height="38" rx="7" fill="#000000"/>
      <rect x="102" y="48" width="38" height="38" rx="7" fill="#000000"/>
    </g>
  </svg>
);

const WalletConnector = () => {
  const { isConnected, walletAddress, balance, chainId, walletType, formatAddress } = useWallet();

  const chains = {
    '0x1': { name: 'Ethereum', color: 'purple' },
    '0x38': { name: 'BSC', color: 'yellow' },
    '0xa4b1': { name: 'Arbitrum', color: 'blue' },
    '0xa': { name: 'Optimism', color: 'red' },
    '0x2105': { name: 'Base', color: 'indigo' }
  };

  const getWalletName = () => {
    if (walletType === 'okx') return 'OKX Wallet';
    return 'MetaMask';
  };

  const getWalletIcon = () => {
    if (walletType === 'okx') return <OKXIcon />;
    return <MetaMaskIcon />;
  };

  const copyAddress = () => {
    navigator.clipboard.writeText(walletAddress);
  };

  return (
    <div className="p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-black text-white mb-2">Wallet Connection</h1>
        <p className="text-gray-400 mb-8">Connect your wallet to start trading</p>

        <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl shadow-2xl p-6 border border-gray-800 mb-6">
          {!isConnected ? (
            <div className="text-center py-8">
              <div className="bg-gray-800 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Wallet className="w-10 h-10 text-gray-400" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">No Wallet Connected</h2>
              <p className="text-gray-400 mb-6">Use the Connect Wallet button in the header to get started</p>
            </div>
          ) : (
            <div>
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-16 h-16 rounded-2xl flex items-center justify-center p-2">
                    {getWalletIcon()}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-400" />
                      <span className="text-sm font-bold text-green-400">CONNECTED</span>
                    </div>
                    <h2 className="text-2xl font-black text-white">{getWalletName()}</h2>
                    <p className="text-gray-400 text-sm">{formatAddress(walletAddress)}</p>
                  </div>
                </div>
              </div>

              <div className="grid md:grid-cols-3 gap-4">
                <div className="bg-black rounded-xl p-4 border border-gray-800">
                  <p className="text-xs font-bold text-gray-400 mb-1">WALLET ADDRESS</p>
                  <div className="flex items-center gap-2">
                    <p className="text-white font-mono text-sm">{formatAddress(walletAddress)}</p>
                    <button
                      onClick={copyAddress}
                      className="text-[#50ffff] hover:text-[#476bff] transition"
                      title="Copy address"
                    >
                      <ExternalLink className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                <div className="bg-black rounded-xl p-4 border border-gray-800">
                  <p className="text-xs font-bold text-gray-400 mb-1">BALANCE</p>
                  <p className="text-2xl font-black text-white">{balance} ETH</p>
                </div>

                <div className="bg-black rounded-xl p-4 border border-gray-800">
                  <p className="text-xs font-bold text-gray-400 mb-1">NETWORK</p>
                  <div className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full bg-${chains[chainId]?.color || 'gray'}-500`}></div>
                    <p className="text-lg font-bold text-white">
                      {chains[chainId]?.name || 'Unknown'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {isConnected && (
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl shadow-2xl p-6 border border-gray-800">
            <h3 className="text-xl font-black text-white mb-4">Ready to Trade</h3>
            <p className="text-gray-400 text-sm mb-4">
              Your wallet is connected and ready. You can now proceed to execute swaps on DEXes.
            </p>
            <div className="bg-gradient-to-r from-[#476bff]/20 to-[#50ffff]/20 border border-[#476bff] rounded-xl p-4">
              <div className="flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-[#50ffff] flex-shrink-0 mt-0.5" />
                <div className="text-sm text-gray-300">
                  <p className="font-bold text-white mb-1">Next Steps:</p>
                  <ul className="space-y-1 text-xs">
                    <li>• Ensure you have sufficient balance for gas fees</li>
                    <li>• Make sure you're on the correct network for your trade</li>
                    <li>• Always verify transaction details before confirming</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletConnector;